<template>
  <a-drawer width="55%" :visible="open" @close="onClose" :destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules" layout="vertical">
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item label="师傅订单ID" prop="masterOrderId">
            <a-input-number v-model="form.masterOrderId" style="width: 100%" :min="1" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="雇主订单ID" prop="customerOrderId">
            <a-input-number v-model="form.customerOrderId" style="width: 100%" :min="1" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="师傅用户ID" prop="masterUserId">
            <a-input-number v-model="form.masterUserId" style="width: 100%" :min="1" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="工种ID快照" prop="categoryId">
            <a-input-number v-model="form.categoryId" style="width: 100%" :min="0" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="订单类型" prop="orderType">
            <a-select v-model="form.orderType" placeholder="请选择" allow-clear>
              <a-select-option :value="0">找个人</a-select-option>
              <a-select-option :value="1">找企业</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="是否触发保证金" prop="isTriggerBond">
            <a-select v-model="form.isTriggerBond" placeholder="请选择" allow-clear>
              <a-select-option :value="false">否</a-select-option>
              <a-select-option :value="true">是</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="雇主订单总金额" prop="orderTotalAmount">
            <a-input-number v-model="form.orderTotalAmount" style="width: 100%" :min="0" :step="0.01" :precision="2" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="触发阈值" prop="triggerThresholdAmount">
            <a-input-number v-model="form.triggerThresholdAmount" style="width: 100%" :min="0" :step="0.01" :precision="2" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="应付总金额" prop="payableAmount">
            <a-input-number v-model="form.payableAmount" style="width: 100%" :min="0" :step="0.01" :precision="2" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="已支付金额" prop="paidAmount">
            <a-input-number v-model="form.paidAmount" style="width: 100%" :min="0" :step="0.01" :precision="2" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="已退还金额" prop="refundAmount">
            <a-input-number v-model="form.refundAmount" style="width: 100%" :min="0" :step="0.01" :precision="2" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="已扣减金额" prop="deductAmount">
            <a-input-number v-model="form.deductAmount" style="width: 100%" :min="0" :step="0.01" :precision="2" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="剩余待退/可扣" prop="unreturnedAmount">
            <a-input-number v-model="form.unreturnedAmount" style="width: 100%" :min="0" :step="0.01" :precision="2" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="支付状态" prop="payStatus">
            <a-input-number v-model="form.payStatus" style="width: 100%" :min="0" :max="3" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="结算状态" prop="settleStatus">
            <a-input-number v-model="form.settleStatus" style="width: 100%" :min="0" :max="5" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="支付方式" prop="payType">
            <a-input-number v-model="form.payType" style="width: 100%" :min="1" :max="3" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="支付截止时间" prop="expireTime">
            <a-date-picker
              v-model="form.expireTime"
              show-time
              format="YYYY-MM-DD HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 100%"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="支付成功时间" prop="payTime">
            <a-date-picker
              v-model="form.payTime"
              show-time
              format="YYYY-MM-DD HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 100%"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="关闭时间" prop="closeTime">
            <a-date-picker
              v-model="form.closeTime"
              show-time
              format="YYYY-MM-DD HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 100%"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="退款完成时间" prop="refundFinishTime">
            <a-date-picker
              v-model="form.refundFinishTime"
              show-time
              format="YYYY-MM-DD HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 100%"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="扣减完成时间" prop="deductFinishTime">
            <a-date-picker
              v-model="form.deductFinishTime"
              show-time
              format="YYYY-MM-DD HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 100%"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="备注" prop="remark">
            <a-input v-model="form.remark" type="textarea" allow-clear />
          </a-form-model-item>
        </a-col>
      </a-row>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">保存</a-button>
          <a-button type="dashed" @click="cancel">取消</a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { addOrderMasterBond, getOrderMasterBond, updateOrderMasterBond } from '@/api/order/masterBond'

function emptyForm() {
  return {
    id: null,
    masterOrderId: null,
    customerOrderId: null,
    masterUserId: null,
    categoryId: null,
    orderType: 0,
    orderTotalAmount: null,
    triggerThresholdAmount: null,
    isTriggerBond: false,
    payableAmount: null,
    paidAmount: null,
    refundAmount: null,
    deductAmount: null,
    unreturnedAmount: null,
    payStatus: 0,
    settleStatus: 0,
    payType: null,
    expireTime: null,
    payTime: null,
    closeTime: null,
    refundFinishTime: null,
    deductFinishTime: null,
    remark: null
  }
}

export default {
  name: 'OrderMasterBondCreateForm',
  data() {
    return {
      submitLoading: false,
      formTitle: '',
      form: emptyForm(),
      formType: 1,
      open: false,
      rules: {
        masterOrderId: [{ required: true, message: '不能为空', trigger: 'blur' }],
        customerOrderId: [{ required: true, message: '不能为空', trigger: 'blur' }],
        masterUserId: [{ required: true, message: '不能为空', trigger: 'blur' }],
        orderType: [{ required: true, message: '不能为空', trigger: 'change' }]
      }
    }
  },
  methods: {
    onClose() {
      this.open = false
    },
    cancel() {
      this.open = false
      this.reset()
    },
    reset() {
      this.formType = 1
      this.form = emptyForm()
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    handleAdd() {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '新增师傅抢单保证金'
    },
    handleUpdate(row) {
      this.reset()
      this.formType = 2
      const id = row.id
      getOrderMasterBond({ id }).then(response => {
        const d = response.data
        this.form = {
          ...emptyForm(),
          ...d,
          isTriggerBond: d.isTriggerBond === true || d.isTriggerBond === 1
        }
        this.open = true
        this.formTitle = '编辑师傅抢单保证金'
      })
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        const payload = { ...this.form }
        if (this.formType === 1) {
          delete payload.id
        }
        const submit = payload.id != null ? updateOrderMasterBond(payload) : addOrderMasterBond(payload)
        submit
          .then(() => {
            this.$message.success(payload.id != null ? '修改成功' : '新增成功', 3)
            this.open = false
            this.$emit('ok')
          })
          .finally(() => {
            this.submitLoading = false
          })
      })
    }
  }
}
</script>
